<template>
  <el-row class="bg-bordered" type="flex" justify="center" :gutter="24">

    <el-col v-if="rtxActive && rtxActive > 0" :span="4" :offset="1" align="center">
      <dash-text caption="Active" :value="rtxActive" icon="fa fa-tasks" align="center" color="#0EABDD" caption-color="slategrey" no-plural  :on-click="showActive" />
    </el-col>

    <el-col v-if="rtxRejected && rtxRejected > 0" :span="4" :offset="1" align="center">
      <dash-text caption="Rejected" :value="rtxRejected" icon="fa fa-exclamation-triangle" align="center" color="#F8D83A" caption-color="slategrey" no-plural :on-click="showRejected" />
    </el-col>

    <el-col v-if="rtxClosed && rtxClosed > 0" :span="4" :offset="1" align="center">
      <dash-text caption="Closed" :value="rtxClosed" icon="fa fa-flag" align="center" color="#64CD75" caption-color="slategrey" no-plural  :on-click="showClosed" />
    </el-col>

  </el-row>

</template>

<script>

export default {

  props: {
    status: {
      type: String,
      default: 'active'
    },

    rejected: {
      type: Number,
      default: null
    },

    active: {
      type: Number,
      default: null
    },

    closed: {
      type: Number,
      default: null
    },

    change: {
      type: Function,
      default: null
    }

  },


  methods: {

    statusChanged () {
      if (this.change) {
        this.change(this.reqStatus)
      }
    },

    showActive () {
      this.reqStatus = 'active'
      this.statusChanged()
    },

    showRejected () {
      this.reqStatus = 'rejected'
      this.statusChanged()
    },

    showClosed () {
      this.reqStatus = 'closed'
      this.statusChanged()
    }

  },


  watch: {
    active: function (a) {
      this.rtxActive = Number(a)
    },

    rejected: function (r) {
      this.rtxRejected = Number(r)
    },

    closed: function (c) {
      this.rtxClosed = Number(c)
    }

  },

  data () {
    return {
      reqStatus: this.status,
      rtxActive: this.active,
      rtxRejected: this.rejected,
      rtxClosed: this.closed
    }
  }


}

</script>



// WEBPACK FOOTER //
// RequestStats.vue?0808c7b7